/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { UpdateSystemConfigurationRequest } from '../../../../types/superuser/UpdateSystemConfigurationRequest';
import { SystemConfigurationFormValues } from '../../../SystemConfigurationPage/SystemConfigurationPage.types';

export const getData = (values: SystemConfigurationFormValues): UpdateSystemConfigurationRequest => ({
  smtpHost: values.smtpHost?.trim() || null,
  smtpPort: Number(values.smtpPort) || null,
  smtpSecure: values.useSmtp ? values.smtpSecure : null,
  smtpUser: values.smtpUser?.trim() || null,
  smtpPass: values.smtpPass?.trim() || null,
  enquiryEmails: values.enquiryEmails.trim(),
  enquiryEmailLanguage: values.enquiryEmailLanguage,
  allowServiceCreation: values.allowServiceCreation,
  showInstanceCost: values.showInstanceCost,
  showSupportCost: values.showSupportCost,
  minCpuLimit: Number(values.minCpuLimit) || null,
  maxCpuLimit: Number(values.maxCpuLimit) || null,
  minMemoryLimit: Number(values.minMemoryLimit) || null,
  maxMemoryLimit: Number(values.maxMemoryLimit) || null,
  minStorageLimit: Number(values.minStorageLimit) || null,
  maxStorageLimit: Number(values.maxStorageLimit) || null,
  minReplicasLimit: Number(values.minReplicasLimit),
  maxReplicasLimit: Number(values.maxReplicasLimit),
  currency: values.currency,
  cpuPricePerMonth: Number(values.cpuPricePerMonth) || 0,
  memoryPricePerMonth: Number(values.memoryPricePerMonth) || 0,
  storagePricePerMonth: Number(values.storagePricePerMonth) || 0,
  cpuRequestToLimitMultiplier: Number(values.cpuRequestToLimitMultiplier) || 1,
  smtpFromEmail: values.smtpFromEmail || null,
  emailAddress: values.emailAddress,
  emailToken: values.emailToken,
  imprint: values.imprint,
});
